class GetCurrency {
  constructor() {
    this.getWithId = (id) => {
      switch (id) {
        case "5d821d5e5ed386001a780255": // Karachi
        case "5d7e04bb379c41001a40e24c": // Islamabad
        case "5d0271ec1a16790018a5305d": // Lahore
          return "PKR";
        case "5c2f43865d8b280018078114": // Nairobi
          return "KES";
        default:
          // Cairo, Alexandria or else
          return "EGP";
      }
    };

    this.getWithName = (name) => {
      switch (name) {
        case "karachi":
        case "islamabad":
        case "lahore":
          return "PKR";
        case "nairobi":
          return "KES";
        default:
          // Cairo, Alexandria or else
          return "EGP";
      }
    };
  }
}

export default GetCurrency;



// WEBPACK FOOTER //
// ./src/services/getCurrency/getCurrency.service.js